
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import "./SpecialFacility.css";
import Aos from 'aos';
import './aos.css';
import React, { useState, useEffect } from 'react';

function Transport() {
  useEffect(() => {
      Aos.init({});
    }, [])
  return (
    // <div className="facility-container">
    //   <div className="facility-box">
    //     <h2 className="facility-title">Transport</h2>
    //     {/* <p className="facility-text">
    //       <div>Transport Admission to the Academy does not automatically guarantee transport service to every student.
    //         The Academy buses will operate on routes officially recognized by the management. Requests for any change of route by a parent or small group of parents will not be considered.
    //         No legal recourse will be available from ACE incase of any mishap involving any student.
    //         No parent is permitted to deal directly with the driver of any bus. Problems relating to transport must be referred to the Administration. Under no circumstances should any parent give instructions to bus drivers or teachers for any matter whatsoever. Parents are not allowed to speak to or deal with any child on the bus other than their own but should report only issues to the Academy authorities.
    //         Parents should not hold up a bus for a child who is not ready. Students should be ready to board the bus five minutes before the prescribed time at the correct bus stop. Buses cannot wait for students in the morning, if they are late, it is the parents responsibility to bring them to the Academy.
    //         If parents decide not to use the Academy transport on any particular day and plan to collect their students from the Academy with their own transport before the end of the day, they should inform Reception at the Academy. Parents are requested to refrain from breaking this routine as it upsets the normal Academy transport arrangements.
    //         Part of good discipline is proper behaviour in the buses. Bad behaviour might result in the termination of that student’s use of Academy transport.
    //         Transport fee might change any time during the academic year, due to rising costs.</div>
    //     </p> */}
    //     <ul>
    //       <li>Admission to the Academy does not automatically guarantee transport service to every student.</li>
    //       <li>The Academy buses will operate on routes officially recognized by the management. Requests for any change of route by a parent or small group of parents will not be considered.</li>
    //       <li>No legal recourse will be available from ACE incase of any mishap involving any student.</li>
    //       <li>No parent is permitted to deal directly with the driver of any bus. Problems relating to transport must be referred to the Administration. Under no circumstances should any parent give instructions to bus drivers or teachers for any matter whatsoever. Parents are not allowed to speak to or deal with any child on the bus other than their own but should report only issues to the Academy authorities.</li>
    //       <li>Parents should not hold up a bus for a child who is not ready. Students should be ready to board the bus five minutes before the prescribed time at the correct bus stop. Buses cannot wait for students in the morning, if they are late, it is the parents responsibility to bring them to the Academy.</li>
    //       <li>If parents decide not to use the Academy transport on any particular day and plan to collect their students from the Academy with their own transport before the end of the day, they should inform Reception at the Academy. Parents are requested to refrain from breaking this routine as it upsets the normal Academy transport arrangements.</li>
    //       <li>Part of good discipline is proper behaviour in the buses. Bad behaviour might result in the termination of that student’s use of Academy transport.</li>
    //       <li>Transport fee might change any time during the academic year, due to rising costs.</li>
    //     </ul>



    //   </div>
    // </div>
    <Container className="my-5">
      <Row>
        <Col xs={6} md={5}>
        <div data-aos="flip-left" data-aos-duration="2500">
          <Image
            src="imagesspecialfacilities/Transport.jpg"
            rounded
            style={{ width: '100%', objectFit: 'cover', marginTop: '20px', boxShadow: ' rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px, rgba(0, 0, 0, 0.35) 0px 5px 15px' }}
          />
          </div>
        </Col>
        <Col xs={6} md={7}>
          <div className="facility-text">
            <h2 className="facility-title">Transport</h2>
            <br />
            <ul style={{textAlign:'justify'}}>
              <li>Admission to the Academy does not automatically guarantee transport service to every student.</li>
              <li>The Academy buses will operate on routes officially recognized by the management. Requests for any change of route by a parent or small group of parents will not be considered.</li>
              <li>No legal recourse will be available from ACE incase of any mishap involving any student.</li>
            <li>No parent is permitted to deal directly with the driver of any bus. Problems relating to transport must be referred to the Administration. Under no circumstances</li>

            </ul>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
       
          <ul style={{textAlign:'justify'}}>
            should any parent give instructions to bus drivers or teachers for any matter whatsoever. Parents are not allowed to speak to or deal with any child on the bus other than their own but should report only issues to the Academy authorities.
            <li>Parents should not hold up a bus for a child who is not ready. Students should be ready to board the bus five minutes before the prescribed time at the correct bus stop. Buses cannot wait for students in the morning, if they are late, it is the parents responsibility to bring them to the Academy.</li>
            <li>If parents decide not to use the Academy transport on any particular day and plan to collect their students from the Academy with their own transport before the end of the day, they should inform Reception at the Academy. Parents are requested to refrain from breaking this routine as it upsets the normal Academy transport arrangements.</li>
            <li>Part of good discipline is proper behaviour in the buses. Bad behaviour might result in the termination of that student’s use of Academy transport.</li>
            <li>Transport fee might change any time during the academic year, due to rising costs.</li>
          </ul>
        </Col>
      </Row>

    </Container>
  );
}

export default Transport;
